import { jsx } from 'panel';
import { ItemsMenuEl } from 'common/components/items-menu';
import { SelectEl, THEME as SelectElTheme } from 'common/components/select';
import { renderEventItemContextPanel } from './context-panel';
export function template() {
  const SelectSortingHeaderEl = () => {
    return jsx("div", {
      sel: '.sorting-selector-header'
    }, jsx(SelectEl, {
      attrs: {
        disabled: this.helpers.isLoading(),
        sections: [{
          items: this.helpers.getSortingOptionSectionItems()
        }],
        theme: SelectElTheme.TERTIARY,
        'always-show-caret': true,
        'menu-width': 120
      },
      key: "Selectadsadsadsa",
      on: {
        change: this.helpers.handleSortChange
      }
    }));
  };

  return jsx("div", {
    sel: '.child-menu-items-menu'
  }, this.attr("open") && jsx(null, null, this.helpers.hasSelectSortingHeader() && jsx(SelectSortingHeaderEl, null), jsx(ItemsMenuEl, {
    attrs: {
      'empty-message': "No items found",
      multiple: this.attr("multiple"),
      'search-filter': this.helpers.getSearchFilter(),
      'disable-search-sort': this.getContext("eventsController").isNewMenu(),
      'enforce-limit-when-searching': true
    },
    hook: {
      insert: this.helpers.handleItemsMenuInsert
    },
    on: {
      click: ev => ev.stopPropagation(),
      clickItem: ev => this.handleClickItem(ev),
      clickExpanderItem: ev => this.handleExpandItemClick(ev),
      focusItem: ev => this.helpers.showItemDetails(ev)
    },
    props: {
      sections: this.getSections(),
      keydownProxyEl: this.state.keydownProxyEl,
      sectionsFromInputFn: this.helpers.sectionsFromInput,
      customSearchMatcherFn: this.helpers.customSearchMatcherFn
    }
  }), this.state.tooltipData && renderEventItemContextPanel({
    tooltipData: this.state.tooltipData,
    track: this.trackEvent.bind(this),
    handleSelect: _ref => {
      let {
        item
      } = _ref;
      return this.triggerModal(item.value);
    },
    handleDelete: _ref2 => {
      let {
        id
      } = _ref2;
      return this.handleCustomEventDelete(id);
    },
    additionalArgs: {
      'all-data-groups': this.attr("all-data-groups"),
      'project-has-people': this.attr("project-has-people"),
      'track-name': this.attr("track-name")
    }
  })));
}